<template>
  <div style="display: contents">
    <tr class="first odd">
      <td class="product-cart-image product-cart-equal">
        <div class="product-cell-inner-wrap flex-center">
          <TheMagazineImage
            :href="getItemData('edit_url') || getItemData('url_path')"
            :item="item"
            :show-save-overlay="false"
            :show-free-gift-overlay="false"
            :image-src="getItemData('image_src')"
          />
        </div>
      </td>

      <td v-if="isEGiftCard" class="product-cart-info product-cart-equal">
        <div class="product-cell-inner-wrap">
          <h2 class="product-name">E-Gift Card</h2>
          <p class="product-sub-name">£{{ item.offer.price }} E-Gift Card</p>
          <p v-if="getItemData('from_name')" class="gf-info--nooverflow wrap"><b>From: </b> {{ getItemData('from_name') }}</p>
          <p v-if="getItemData('to_name')" class="gf-info wrap"><b>Send to: </b> {{ getItemData('to_name') }} {{ getItemData('to_email') }}</p>
          <p v-if="getItemData('message')" class="gf-info--nooverflow wrap"><b>Message: </b>{{ getItemData('short_message') }}</p>
          <p class="gf-info"><b>Delivery Date: </b>{{ getItemData('to_date') }}</p>
          <p>
            <br />
            <a style="display: inline" :href="getItemData('edit_url')" title="Edit E-Gift Card" class="product-delivery btn-remove">Edit Card</a>
          </p>
        </div>
      </td>

      <td v-else-if="isGiftCard" class="product-cart-info product-cart-equal">
        <div class="product-cell-inner-wrap">
          <h2 class="product-name">Gift Card</h2>
          <p class="product-sub-name">£{{ item.offer.price }} Gift Card</p>
          <p class="product-sub-name">£2.99 UK delivery has been added to the price</p>
          <p v-if="getItemData('message')" class="gf-info--nooverflow wrap"><b>Message: </b>{{ getItemData('short_message') }}</p>

          <div class="gift-checkboxes" style="margin-top:10px">
            <div class="gift-options">
              <label v-if="item?.offer?.allow_as_gift">
                <input
                  v-model="giftOptionsCheckbox.allow_as_gift"
                  type="checkbox"
                  @change="handleCheckboxClick({ id: id, checked: giftOptionsCheckbox.allow_as_gift, flag: 'allow_as_gift' })"
                />
                <p>{{ getIsGiftLabel }}</p>
                <span class="checkmark"></span>
              </label>

              <label v-if="item?.offer?.allow_as_xmas_gift">
                <input
                  v-model="giftOptionsCheckbox.allow_as_xmas_gift"
                  type="checkbox"
                  @change="handleCheckboxClick({ id: id, checked: giftOptionsCheckbox.allow_as_xmas_gift, flag: 'allow_as_xmas_gift' })"
                />
                <p>{{ getIsXMASGiftLabel }}</p>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <p>
            <br />
            <a style="display: inline" :href="getItemData('edit_url')" title="Edit Gift Card" class="product-delivery btn-remove">Edit Card</a>
          </p>
        </div>
      </td>

      <td v-else-if="isPocketmagsPlus" class="product-cart-info product-cart-equal">
        <div class="product-cell-inner-wrap">
          <h2 class="product-name">Pocketmags Plus+ Subscription</h2>
          <p class="product-sub-name">{{ item.custom_fields.offer.title }}</p>
          <p v-if="getItemData('from_name')" class="gf-info--nooverflow wrap"><b>From: </b> {{ getItemData('from_name') }}</p>
          <p v-if="getItemData('to_name')" class="gf-info wrap"><b>Send to: </b> {{ getItemData('to_name') }} {{ getItemData('to_email') }}</p>
          <p v-if="getItemData('message')" class="gf-info--nooverflow wrap"><b>Message: </b>{{ getItemData('short_message') }}</p>
          <p class="gf-info"><b>Delivery Date: </b>{{ getItemData('to_date') }}</p>
          <p>
            <br />
            <a style="display: inline" :href="getItemData('edit_url')" title="Edit" class="product-delivery btn-remove">Edit</a>
          </p>
        </div>
      </td>

      <td v-else-if="isCrossSell" class="product-cart-info product-cart-equal">
        <div class="product-cell-inner-wrap">
          <h2 class="product-name">
            {{ getItemData('title') }}
          </h2>
          <p class="product-delivery">* Please note this item will be sent to the billing address.</p>
          <p v-if="item?.offer?.type !== '1 ISSUE'" class="product-delivery">FREE delivery</p>
          <p v-if="getItemData('free_gift')" class="free-gift">{{ getItemData('free_gift') }}</p>
        </div>
      </td>

      <td v-else class="product-cart-info product-cart-equal">
        <div class="product-cell-inner-wrap">
          <h2 class="product-name">
            {{ getItemData('title') }}
          </h2>
          <p class="product-sub-name">{{ getItemData('offer_name') }}</p>
          <p v-if="getItemData('num_of_issues')" class="product-issues">{{ getItemData('num_of_issues_label') }}</p>
          <p v-if="item?.offer?.type !== '1 ISSUE'" class="product-delivery">FREE delivery</p>
          <p v-if="getItemData('free_gift')" class="free-gift">{{ getItemData('free_gift') }}</p>

          <div class="gift-checkboxes" style="margin-top:10px">
            <div class="gift-options">
              <label v-if="item?.offer?.allow_as_gift">
                <input
                  v-model="giftOptionsCheckbox.allow_as_gift"
                  type="checkbox"
                  @change="handleCheckboxClick({ id: id, checked: giftOptionsCheckbox.allow_as_gift, flag: 'allow_as_gift' })"
                />
                <p>{{ getIsGiftLabel }}</p>
                <span class="checkmark"></span>
              </label>

              <label v-if="item?.offer?.allow_as_xmas_gift">
                <input
                  v-model="giftOptionsCheckbox.allow_as_xmas_gift"
                  type="checkbox"
                  @change="handleCheckboxClick({ id: id, checked: giftOptionsCheckbox.allow_as_xmas_gift, flag: 'allow_as_xmas_gift' })"
                />
                <p>{{ getIsXMASGiftLabel }}</p>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </td>

      <td class="product-cart-payment sub-options-content product-cart-mobile-row" align="center">
        <div class="product-cell-inner-wrap">
          <span class="cart-mobile-label">Payment Method</span>
          <span class="cards cc_small">
            <PaymentImages :offer-payment-type="item.offer.payment_type" :is-mobile="isFromMobile" :is-giftcard="isGiftCard || isEGiftCard" :width="140" :height="88" />
          </span>
        </div>
      </td>

      <td class="product-cart-price product-cart-mobile-row last" align="center">
        <div class="product-cell-inner-wrap">
          <span class="product-cell-payment-mobile sub-options-content">
            <span class="sub-options-content cards cc_small">
              <PaymentImages
                :offer-payment-type="item.offer.payment_type"
                :is-giftcard="isGiftCard || isEGiftCard"
                :is-checkout-cart="true"
                :width="140"
                :height="88"
                :is-inline="isFromMobile"
                :is-mobile="isFromMobile"
              />
            </span>
          </span>

          <span class="cart-mobile-label">Price</span>
          <span class="cart-price"> {{ formatCurrency(item.offer.price + (item?.offer?.postage || 0)) }} </span>
        </div>
      </td>
    </tr>
    <tr class="even">
      <td class="product-cart-remove" align="left" colspan="2">
        <a title="Remove Item" class="btn-remove btn-remove2" @click.stop="handleClickAction(item, 'remove')">- Remove Item</a>
      </td>
      <td v-if="isDefaultProduct" style="text-align: right; padding: 0 30px 10px;" class="product-cart-add last" colspan="2">
        <a title="Add Item" class="btn-remove btn-remove2" @click.stop="handleClickAction(item, 'add')">
          + Add Again
        </a>
      </td>
    </tr>
    <transition name="fade">
      <div v-if="showNotification" class="product__notification">You reach the MAX qty allowed for {{ item.title }}</div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatCurrency } from '~/lib/util/basket'
import { getGA4EcommerceNullPayload, getGA4EcommerceBasketActionPayload } from '~/lib/util/gtmGA4'
import { sendSSAPIAddToCart, createUniqueFBEventId } from '~/lib/util/fb'
import basketMixin from '~/mixins/basket.vue'
import baseProductMixin from '~/mixins/baseProduct.vue'

export default {
  name: 'CheckoutCartProduct',
  serverCacheKey() {
    return false
  },
  components: {
    PaymentImages: () => import('~/components/common/product/PaymentImages.vue'),
    TheMagazineImage: () => import('~/components/common/TheMagazineImage')
  },
  mixins: [basketMixin, baseProductMixin],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  fetch() {},
  data() {
    return {
      isFromMobile: this.$ua.isFromIphone() || this.$ua.isFromAndroidMobile(),
      showNotification: false,
      imageSrcQS: '?fm=png&auto=format&fit=fill&fill=solid&bg=0FFF&w=210',
      giftOptionsCheckbox: {
        allow_as_gift: this?.item?.options?.allow_as_gift || false,
        allow_as_xmas_gift: this?.item?.options?.allow_as_xmas_gift || false
      }
    }
  },
  computed: {
    ...mapGetters({
      basketItem: 'basket/item'
    }),
    item() {
      const ret = this.basketItem(this.id)
      console.log('COUMPUTED item=', ret)
      return ret
    },
    getIsGiftLabel() {
      if (this.isGiftCard) {
        return 'This is a gift '
      }
      return 'This is a gift (send next available issue)'
    },
    getIsXMASGiftLabel() {
      return 'This is a Christmas gift (deliver after Christmas)'
    }
  },

  mounted() {
    this.giftOptionsCheckbox.allow_as_gift = this?.item?.options?.allow_as_gift || false
    this.giftOptionsCheckbox.allow_as_xmas_gift = this?.item?.options?.allow_as_xmas_gift || false
  },

  methods: {
    handleCheckboxClick({ id, checked, flag }) {
      if (flag === 'allow_as_gift') {
        this.giftOptionsCheckbox = {
          allow_as_gift: checked,
          allow_as_xmas_gift: false
        }
      }
      if (flag === 'allow_as_xmas_gift') {
        this.giftOptionsCheckbox = {
          allow_as_gift: false,
          allow_as_xmas_gift: checked
        }
      }
      this.$nuxt.$emit('GIFT_OPTION_CHANGE', { id, checked, flag })
    },
    formatCurrency(value) {
      return formatCurrency(value)
    },
    async handleClickAction(item, action) {
      this.$nuxt.$emit('TOGGLE_LOADING', true)
      console.log(`CHECKOUT_CART handleClickAction action=${action} basket.id=${this.$store.state.basket.id} item.sku=${item?.sku} item.offer.sku=${item?.offer?.sku}`)

      // Update the BE Basket data
      const ret = await this.updateBasket({ item, action, type: item.type })

      if (ret.error) {
        // Error, show an overlay on the page
        this.$nuxt.$emit('SHOW_NOTIFICATION', { data: ret.error, show: true })
      } else {
        // Facebook Event Deduplication
        let eventId
        switch (action) {
          case 'add':
            eventId = createUniqueFBEventId('AddToCart')
            break
          case 'remove':
          case 'delete':
            eventId = createUniqueFBEventId('RemoveFromCart')
            break
          default:
            break
        }
        // Customer email address
        const email = this.$store.getters['s/email']
        // GA4 events for each Basket Button's Click
        this.$config.GA4Syntax && this.$config.GA4FireEcommerceNull && this.$gtm && this.$gtm.push(getGA4EcommerceNullPayload())
        this.$config.GA4Syntax && this.$gtm && this.$gtm.push(getGA4EcommerceBasketActionPayload({ action, item, eventId, email }))

        if (action === 'add') {
          // FB v12.0
          const eventSourceUrl = `${this.$config.baseURL}${this.$route.fullPath}`
          // Facebook Server-side API AddToCart
          sendSSAPIAddToCart({ context: this, item, parameters: { eventId, eventSourceUrl } })
        }
        this.$nuxt.$emit('TOGGLE_LOADING', false)
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-remove {
  &:hover {
    cursor: pointer;
  }
}
.gift-options label {
  text-align: left;
  width: 100%;
  margin: unset;
}
.gift-options input {
  margin: 3px 5px 3px 0px;
}
.product-cell-inner-wrap p {
  width: 100%;
}
.form-section-container a {
  display: contents;
  flex: 1 1 150px;
  min-width: 100px;
}
</style>
